module.exports = __webpack_public_path__ + "static/img/menu-bg.3a3df6f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/menu-bg.png
// module id = CiEe
// module chunks = 2